export default {
    props: [ 'imobiliaria' ],
    mounted() {
      document.title = "Quem Somos | " + this.imobiliaria.nome
    }
}
